import type React from "react";
import { useCallback } from "react";

import { isPaidExcelAllowed } from "app/services/PaidExcelService/isPaidExcelAllowed";
import { swSettings } from "app/common/services/swSettings";
import { DownloadButtonMenu } from "app/components/React/DownloadButtonMenu/DownloadButtonMenu";
import { allTrackers } from "app/services/track/track";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { buildExcelDownloadUrl, calculateTotalCount } from "./utils";

const DEFAULT_EXCEL_ENDPOINT = "/api/searchoverview/overview/traffic/excel";

interface IExcelDownloadProps {
    queryParams: Record<string, unknown>;
    metricName: string;
}

const ExcelDownload: React.FC<IExcelDownloadProps> = ({ queryParams, metricName }) => {
    const { performanceOverTimeChartCurrency } = proNavigator.getParams();

    // Build URL for Excel download using template literals
    const excelLink = buildExcelDownloadUrl(DEFAULT_EXCEL_ENDPOINT, {
        ...queryParams,
        currency: performanceOverTimeChartCurrency,
    });

    // Track Excel download click
    const onExcelClick = useCallback(() => {
        allTrackers.dispatchTrackEvent("Download", "submit-ok", `Over Time Graph/${metricName}/Excel`);
    }, [metricName]);

    // Check permissions
    const downloadExcelPermitted = Boolean(swSettings.current.resources.IsExcelAllowed);
    const isPaidExcelPermitted = Boolean(isPaidExcelAllowed());

    const totalCount = calculateTotalCount(queryParams);

    return (
        <DownloadButtonMenu
            Excel={true}
            downloadUrl={excelLink}
            exportFunction={onExcelClick}
            excelLocked={!downloadExcelPermitted}
            PaidExcel={isPaidExcelPermitted}
            totalCount={totalCount}
        />
    );
};

export default ExcelDownload;
